import React from "react";
import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import { context } from "../../context/context";
import NewsTable from "./NewsTable";

const News = () => {
    // context
    const {
        setNewsCover,
        setNewsMedia,
        setNewsLinks,
        setTextEditorHTML,
        setNewsTitle,
        setNewsTags,
        setSelectedNewsId,
        setNewsCoverId,
    } = useContext(context);
    // functions
    const handleEmptyFields = () => {
        setNewsTitle("");
        setNewsCover([]);
        setNewsMedia([]);
        setNewsLinks([]);
        setNewsCoverId();
        setTextEditorHTML("");
        setNewsTags([]);
        setSelectedNewsId();
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addNews">
                    <Button onClick={handleEmptyFields} type="primary">
                        اضافه کردن خبر جدید
                    </Button>
                </NavLink>
            </Space>
            <NewsTable />
        </>
    );
};

export default News;
